import moment from 'moment';

export const isValidDate = (date: string): boolean => {
    const dateNumber = new Date(date).getTime();
    return !isNaN(dateNumber);
};

export const isValidRange = (from: string, to: string) => {
    return isValidDate(from) && moment(from).isBefore(moment(to));
};
